// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"styles_loginButton__b72pk","captionContainer":"styles_captionContainer__6Sriv"};